import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './puzzle-notes-mode.actions';
import { Injectable } from '@angular/core';
// @dynamic
@State<boolean>({
  name: 'notesModeState',
  defaults: false,
})
@Injectable()
export class PuzzleNotesModeState {
  @Action(actions.EnableNotesMode)
  EnableNotesMode(store: StateContext<boolean>) {
    store.setState(true);
  }

  @Action(actions.DisableNotesMode)
  DisableNotesMode(store: StateContext<boolean>) {
    store.setState(false);
  }
}
